import React from 'react';
import PricingPlanCard from './PricingPlanCard';
import PricingDescription from './PricingDescription';
import check_img_check_17 from "../../img_new_design_2025/check_17.png";
import check_ko_fond_gris from "../../img_new_design_2025/check_ko_fond_gris.png";
import './detail.css';
import './det_PricingDescription.css';


import WhyUsLayout from './../a_propos_automatic_files/WhyUsLayout.js';

const PricingLayout = (props) => {

  return (
    <div>
      <div className='tarif_head_automatic_files' style={{ width: '90%', marginLeft: '5%' }}>


        <div className="det_block_1">
          <div className="det_block_2">
            <PricingDescription />
          </div>


          <div className="det_block_2_bis" >
            <PricingPlanCard title="Basic" price={props.price_basic} sessions="Jusqu'à 25 Sessions/an" periodicite={'mois'} />
          </div>
          <div className="det_block_3" >
            <div className="popular-badge" >
              <span>LE PLUS POPULAIRE </span>
            </div>

            <PricingPlanCard title="Standard" price={props.price_standard} sessions="Jusqu'à 200 Sessions/an" isHighlighted={true} periodicite={'mois'} />
          </div>
          <div className="det_block_2_bis" >
            <PricingPlanCard title="Gold" price={props.price_gold} sessions="Sessions illimitées/an" periodicite={'mois'} />
          </div>
        </div>


        <div className='position_detail_price' id="detail_plans">

          {/*** Gestion admin */}
          <div className="det_block_1_bis" >
            <h1 className="fonctionnalite_h1" >  Gestion Administrative & Pédagogique</h1>
          </div>


          <div className="det_detail_fonctionnalite_line" >
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" >  Publication catalogue formations (intranet / API) </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2" >


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>



            </div>
          </div>

          <div className="det_detail_fonctionnalite_line" >
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" > Check-list QUALIOPI (automatisé) </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2" >


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>



            </div>
          </div>

          <div className="det_detail_fonctionnalite_line" >
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" > Avis participants / Génération automatique des statistiques  </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2" >


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>



            </div>
          </div>
      
          <div className="det_detail_fonctionnalite_line" >
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" >  Émargement / par email / par QR code / Signature main levée </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2" >


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>



            </div>
          </div>


          <div className="det_detail_fonctionnalite_line" >
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" > Gestion Documents (GED complete) </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2" >


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>



            </div>
          </div>


          <div className="det_detail_fonctionnalite_line" >
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" > Automatisation tâches & étapes QUALIOPI </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2" >


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>



            </div>
          </div>


          <div className="det_detail_fonctionnalite_line" >
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" >Système Interne d'alerte </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2" >


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>



            </div>
          </div>


          <div className="det_detail_fonctionnalite_line" >
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" > Gestion Formateurs (interne/vacataire) / Compétences / Contrat/ etc </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2" >


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>



            </div>
          </div>


          <div className="det_detail_fonctionnalite_line" >
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" > Ressources pédagogique (Salles / Matériels / personnel administratif)</nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2" >


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>



            </div>
          </div>


          <div className="det_detail_fonctionnalite_line" >
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" >Gestion Accès utilisateur & droit selon profils</nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2" >


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>



            </div>
          </div>



          <div className="det_detail_fonctionnalite_line" >
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" > Suivi d'activité / Tableau de bord / BPF </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2" >


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>

            </div>
          </div>





          <div className="det_detail_fonctionnalite_line" >
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" > Gestion des Inscriptions   </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2" >


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>



            </div>
          </div>

          <div className="det_detail_fonctionnalite_line">
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" >  Gestion des Sessions (planifiée, à la demande) </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2">


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>

            </div>
          </div>



          <div className='coupure_fin_fonctionnalite'> &nbsp;</div>

          {/*** CRM */}
          <div className="det_block_1_bis" >
            <h1 className="fonctionnalite_h1" >  Gestion relation client (CRM) </h1>
          </div>

          <div className="det_detail_fonctionnalite_line">
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" >  Intranet Client </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2">


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>

            </div>
          </div>

          <div className="det_detail_fonctionnalite_line">
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" >  Intranet Client </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2">


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>

            </div>
          </div>

          <div className="det_detail_fonctionnalite_line">
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" >  Signature électronique  </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2">


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>

            </div>
          </div>

          <div className="det_detail_fonctionnalite_line">
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" > Devis / Relances Automatisées </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2">


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>

            </div>
          </div>

          <div className="det_detail_fonctionnalite_line">
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" >  Clients, Financeurs </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2">


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>

            </div>
          </div>

          <div className="det_detail_fonctionnalite_line">
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" > Paiements </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2">


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>

            </div>
          </div>

          <div className="det_detail_fonctionnalite_line">
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" > Factures & Avoirs </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2">


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>

            </div>
          </div>

          <div className="det_detail_fonctionnalite_line">
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" > Opportunités d’affaire </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2">


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>

            </div>
          </div>

          <div className="det_detail_fonctionnalite_line">
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" > Intranet Client </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2">


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>

            </div>
          </div>

          <div className="det_detail_fonctionnalite_line">
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" > Gestion Collaborateurs / Affectation tâches/ Suivi avancement </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2">


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>

            </div>
          </div>

          <div className="det_detail_fonctionnalite_line">
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" > Tableau de bord </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2">


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>

            </div>
          </div>




          <div className='coupure_fin_fonctionnalite'> &nbsp;</div>

          {/** E-Learning LSM */}
          <div className="det_block_1_bis" >
            <h1 className="fonctionnalite_h1" >Hébergement de formations (LMS)  </h1>
          </div>
          <div className="det_detail_fonctionnalite_line" >
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" > Plate-forme de E-learning personnalisée (nom domaine, charte graphique) </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2" >


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>

            </div>
          </div>

          <div className="det_detail_fonctionnalite_line" >
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" >Echange prof / apprenant  </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2" >


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>



            </div>
          </div>

          <div className="det_detail_fonctionnalite_line">
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" >  Espace enseignant</nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2">


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>

            </div>
          </div>

          <div className="det_detail_fonctionnalite_line">
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" >  Espace apprenant </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2">


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>

            </div>
          </div>

          <div className="det_detail_fonctionnalite_line">
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" > Classe virtuelle  </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2">


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>

            </div>
          </div>
          <div className="det_detail_fonctionnalite_line">
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" > Suivi temps de connexion apprenants   </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2">


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>

            </div>
          </div>


          <div className="det_detail_fonctionnalite_line">
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" > Social Learning        </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2">


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>

            </div>
          </div>
          <div className="det_detail_fonctionnalite_line">
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" > Export format SCORM    </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2">


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>

            </div>
          </div>
          <div className="det_detail_fonctionnalite_line">
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" >Partage Fichiers   </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2">


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>

            </div>
          </div>



          <div className='coupure_fin_fonctionnalite'> &nbsp;</div>

          {/*** MarketPlace */}
          <div className="det_block_1_bis" >
            <h1 className="fonctionnalite_h1" >  Marketplace </h1>
          </div>
          <div className="det_detail_fonctionnalite_line" >
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" > Mise en ligne de votre formation (Description, Objectif, Programme, etc).  </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2" >


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>

            </div>
          </div>

          <div className="det_detail_fonctionnalite_line" >
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" > Personnalition du prix / Remise client / Tout public par période  </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2" >


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>



            </div>
          </div>

          <div className="det_detail_fonctionnalite_line">
            <div className="det_detail_fonctionnalite_line_1" >
              <nav className="det_detail_fonctionnalite_line_1_desc" >  Génération automatique de leads </nav>
            </div>


            <div className="det_detail_fonctionnalite_line_2">


              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>
              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />
              </div>

              <div className="det_detail_fonctionnalite_line_1_tick" >
                <img src={check_img_check_17} alt="check" className="check-icon" />

              </div>

            </div>
          </div>

          <div className='coupure_fin_fonctionnalite'> &nbsp;</div>
        </div>

      </div>


      <div className='new_a_propos_2025' >
        <WhyUsLayout />
      </div>
    </div>
  );
};

export default PricingLayout;

